<template functional>
    <b-badge
        class="text-uppercase font-weight-500"
        :class="[(data.staticClass || ''), (data.class || '')]"
        :variant="props.tag.color_variant || 'secondary'"
    >  <!-- :class="data.staticClass || ''" -->
        {{ props.tag.name }}
    </b-badge>
</template>

<script>

export default {
    name: 'FeaturedVendorTag',
    functional: true,
    props: {
        tag: {  // pass in the full CompanyTag object
            type: Object,
            required: true,
        }
    },
}
</script>

<style>

</style>